import Env from "../environments";
import { GLOBAL_CONSTANTS } from "../global/constants";
import { ROOT_GLOBAL } from "../global/root";
import { LocalStorage } from "../models/LocalStorage";
import { MINI_APP } from "./miniApp";
import { changeQueryString, getParamUrl } from "./url";

const { detect } = require('detect-browser');
const browser = detect();

const LINK = {
  chrome: Env.DUTY_CAST_EXTENSION_INSTALL_CHROME || "https://chrome.google.com/webstore/detail/dutycast/nfgdckhmemppdbmhhhioindkickfknad",
  "edge-chromium": Env.DUTY_CAST_EXTENSION_INSTALL_EDGE || "https://microsoftedge.microsoft.com/addons/detail/dutycast/pegmkkoecnhncpcaaphambbmmdcakmdd",
  safari: Env.DUTY_CAST_EXTENSION_INSTALL_SAFARI || "https://apps.apple.com/app/dutycast-extension/id1624829281",
  firefox: Env.DUTY_CAST_EXTENSION_INSTALL_FIREFOX || "https://addons.mozilla.org/en-GB/firefox/addon/dutycast",
}

export const getExtensionLink = () => {
  return ROOT_GLOBAL.EXTENSION + window.location.search;
}

export const getStoreLink = () => {
  let url = "";
  if (browser && browser.name) {
    if (browser.os === "Android OS") {
      url = "https://dutycast.app.link";
    } else {
      if (browser.os === "iOS") {
        url = LINK["safari"];
      } else {
        url = LINK[browser.name];
      }
    }
  }
  url = url || LINK.chrome;
  url = url + window.location.search;

  const language = getParamUrl("hl") || LocalStorage.getLanguage();
  url = changeQueryString("hl", language, url);

  return url;
}

export const isTouchDevice = () => {
  // I know, sniffing is a really bad idea, but it works 99% of the times
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  }
  // iPad Pro pretends to be a Mac, but Macs don't have touch controls
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return true;
  }
};

export const isMobileApp = () => {
  // I know, sniffing is a really bad idea, but it works 99% of the times
  if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    return true;
  }
  // iPad Pro pretends to be a Mac, but Macs don't have touch controls
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
};

export const isIpad = () => {
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return true;
  }
  return false;
}

export const isNormaliOS = () => {
  // I know, sniffing is a really bad idea, but it works 99% of the times
  // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
  //   return true;
  // }
  return browser.os === "iOS" || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
};

export const isNormalAndroid = () => {
  // I know, sniffing is a really bad idea, but it works 99% of the times
  return browser.os === "Android OS";
  // if (/Android/i.test(navigator.userAgent)) {
  //   return true;
  // }
};

export const isChromium = () => {
  return !!window.chrome;
}

export const isFireFox = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
}

export function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)?', "g"));
  if (match && match.length > 0) return match[match.length - 1].replace(new RegExp('^(\\s)?' + name + '='), "");
}

export function setCookie(key, value, expiry = 3600, path) {
  var expires = new Date();
  expires.setTime(expires.getTime() + (expiry * 1000));
  document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + (path ? ";  path=" + path : "");
  LocalStorage.isMiniApp() && MINI_APP.setCookie({
    name: key,
    value: value,
    expiresDate: expires.getTime(),
  });
}

window.getCookie = getCookie;
window.setCookie = setCookie;

export function getGaClientId() {
  const id = getCookie(GLOBAL_CONSTANTS.COOKIE.GA);
  if (id) {
    return id;
  }
  let result = "";
  try {
    const trackers = window.ga.getAll();
    if (trackers.length > 0) {
      result = trackers[0].get('clientId');
    }
  } catch {

  }
  // if (!result) {
  //   result = getCookie(GLOBAL_CONSTANTS.COOKIE.FOEID);
  // }
  return result;
}